import React from "react";
import styles from "./Quantum.module.css";

import Quantum01 from "../../../assets/brochure/quantum/Quantum_01.png";
import Quantum02Bg from "../../../assets/brochure/quantum/02 인트로.webp";

import Quantum03Bg from "../../../assets/brochure/quantum/03 테크놀로지 6가지.webp";

import Asset1 from "../../../assets/brochure/quantum/Asset 1.webp";
import Asset2 from "../../../assets/brochure/quantum/Asset 2.webp";
import Asset3 from "../../../assets/brochure/quantum/Asset 3.webp";
import Asset4 from "../../../assets/brochure/quantum/Asset 4.webp";
import Asset5 from "../../../assets/brochure/quantum/Asset 5.webp";
import Asset6 from "../../../assets/brochure/quantum/Asset 6.webp";

import Asset7 from "../../../assets/brochure/quantum/Asset 7.webp";
import Asset8 from "../../../assets/brochure/quantum/Asset 8.webp";
import Asset9 from "../../../assets/brochure/quantum/Asset 9.webp";
import Asset10 from "../../../assets/brochure/quantum/Asset 10.webp";
import Asset11 from "../../../assets/brochure/quantum/Asset 11.webp";
import Asset12 from "../../../assets/brochure/quantum/Asset 12.webp";
import Asset13 from "../../../assets/brochure/quantum/Asset 13.webp";
import Asset14 from "../../../assets/brochure/quantum/Asset 14.webp";
import Asset15 from "../../../assets/brochure/quantum/Asset 15.webp";
import Asset16 from "../../../assets/brochure/quantum/Asset 16.webp";
import Asset17 from "../../../assets/brochure/quantum/Asset 17.webp";

import Asset20 from "../../../assets/brochure/quantum/Quantum_05.png";
import Asset21 from "../../../assets/brochure/quantum/Asset 21.webp";
import Asset22 from "../../../assets/brochure/quantum/Asset 22.webp";
import Asset23 from "../../../assets/brochure/quantum/Asset 23.webp";
import Asset24 from "../../../assets/brochure/quantum/Asset 24.webp";
import Asset25 from "../../../assets/brochure/quantum/Asset 25.webp";
import Asset26 from "../../../assets/brochure/quantum/Asset 26.webp";
import Asset27 from "../../../assets/brochure/quantum/Asset 27.webp";
import Asset28 from "../../../assets/brochure/quantum/Asset 28.webp";
import Asset29 from "../../../assets/brochure/quantum/Asset 29.webp";
import Asset30 from "../../../assets/brochure/quantum/Asset 30.webp";

import Quantum06Bg from "../../../assets/brochure/quantum/Asset 36.webp";
import SafetyIcon from "../../../assets/brochure/quantum/Asset 37.webp";
import SafetyImage from "../../../assets/brochure/quantum/Asset 38.webp";
import PowerIcon from "../../../assets/brochure/quantum/Asset 39.webp";
import PowerImage from "../../../assets/brochure/quantum/Asset 40.webp";

import Quantum07Bg from "../../../assets/brochure/quantum/07 부가기능.webp";

import Asset42 from "../../../assets/brochure/quantum/Asset 42.webp";
import Asset43 from "../../../assets/brochure/quantum/Asset 43.webp";
import Asset44 from "../../../assets/brochure/quantum/Asset 44.webp";
import Asset45 from "../../../assets/brochure/quantum/Asset 45.webp";
import Asset46 from "../../../assets/brochure/quantum/Asset 46.webp";
import Asset47 from "../../../assets/brochure/quantum/Asset 47.webp";

import Asset48 from "../../../assets/brochure/quantum/Asset 49.webp";
import Asset49 from "../../../assets/brochure/quantum/Asset 50.webp";
import Asset50 from "../../../assets/brochure/quantum/Asset 51.webp";
import Asset51 from "../../../assets/brochure/quantum/Asset 52.webp";
import Asset52 from "../../../assets/brochure/quantum/Asset 53.webp";

import quantum09 from "../../../assets/brochure/quantum/Quantum_09.png";
const Quantum = () => {
  return (
    <article className={styles.quantumBrochure}>

      <section className={styles.page01}>
        <img
          src={Quantum01}
          alt="BODYFRIEND QUANTUM"
          className={styles.page01Image}
        />
      </section>

      <section className={styles.page02}>
        <img
          src={Quantum02Bg}
          alt=""
          className={styles.page02Bg}
        />

        <div className={styles.page02Title}>
          <h2>
            High-end
            <br />
            Healthcare Robot
          </h2>
        </div>

        <div className={styles.page02Description}>
          <p>
            The difference in delicacy is the
            <br />
            difference in value.
            <br />
            Feel the QUANTUM details.
          </p>
        </div>
      </section>

<section className={styles.page03}>

  <img
    src={Quantum03Bg}
    alt=""
    className={styles.page03Bg}
  />

  <div className={styles.page03Header}>
    <p>High-end Robot Quantum</p>

    <h2>
      The difference in details that
      <br />
      make up high technology
    </h2>
  </div>

  <div className={styles.page03Features}>

    <div className={styles.page03Feature}>
      <div className={styles.page03Icon}>
        <img src={Asset1} alt="Robotics Technology" />
      </div>

      <h3>
        Robotics
        <br />
        Technology
      </h3>
    </div>

    <div className={styles.page03Feature}>
      <div className={styles.page03Icon}>
        <img
          src={Asset2}
          alt="Audio Speakers by Bang & Olufsen"
        />
      </div>

      <h3>
        Equipped with
        <br />
        <strong>Bang &amp; Olufsen’s</strong>
        <br />
        acoustic technology
      </h3>
    </div>

    <div className={styles.page03Feature}>
      <div className={styles.page03Icon}>
        <img src={Asset3} alt="Premium Natural Leather" />
      </div>

      <h3>
        Premium natural
        <br />
        leather sheet
      </h3>
    </div>

    <div className={styles.page03Feature}>
      <div className={styles.page03Icon}>
        <img src={Asset4} alt="10 inch Touch Tablet" />
      </div>

      <h3>
        10” touch tablet
        <br />
        remote control
      </h3>
    </div>

    <div className={styles.page03Feature}>
      <div className={styles.page03Icon}>
        <img src={Asset5} alt="XD-PRO Massage Module" />
      </div>

      <h3>
        XD-PRO massage
        <br />
        module
      </h3>
    </div>

    <div className={styles.page03Feature}>
      <div className={styles.page03Icon}>
        <img src={Asset6} alt="Spine Mode Massage" />
      </div>

      <h3>
        Spine mode
        <br />
        massage
      </h3>
    </div>

  </div>

</section>

<section
  className={styles.page04}
  aria-labelledby="quantum-page04-title"
>
  
  <header className={styles.page04Header}>
    <span className={styles.page04Badge}>Point 01</span>

    <h2 id="quantum-page04-title">
      HIGH-TECH
      <br />
      <strong>ROBOTICS</strong>
      <br />
      TECHNOLOGY
    </h2>

    <p>
      The <strong>robo-care massage</strong> with each leg
      <br />
      moving separately relaxes and stretches core and lower body muscles.
    </p>
  </header>

  <div className={styles.page04PhotoFeature}>
    <img
      src={Asset7}
      alt="Iliopsoas relaxation massage"
      className={styles.page04MainPhoto}
    />

    <div className={styles.page04OverlayCard}>
      <div className={styles.page04OverlayIcon}>
        <img src={Asset8} alt="" />
      </div>

      <div className={styles.page04OverlayText}>
        <h3>ILIOPSOAS RELAXATION</h3>

        <p>
          THIS COURSE PROVIDES A COOL
          <br />
          STRETCH FOR YOUR CORE MUSCLES.
        </p>
      </div>
    </div>
  </div>

  <div className={styles.page04PhotoFeature}>
    <img
      src={Asset9}
      alt="Cycling massage"
      className={styles.page04MainPhoto}
    />

    <div className={styles.page04OverlayCard}>
      <div className={styles.page04OverlayIcon}>
        <img src={Asset10} alt="" />
      </div>

      <div className={styles.page04OverlayText}>
        <h3>CYCLING</h3>

        <p>
          THIS COURSE USES CYCLING MOTIONS
          <br />
          TO HELP FLEXIBILITY IN THE MUSCLES
          <br />
          AROUND THE KNEE JOINTS.
        </p>
      </div>
    </div>
  </div>

  <div className={styles.page04PhotoFeature}>
    <img
      src={Asset11}
      alt="PNF stretch massage"
      className={styles.page04MainPhoto}
    />

    <div className={styles.page04OverlayCard}>
      <div className={styles.page04OverlayIcon}>
        <img src={Asset12} alt="" />
      </div>

      <div className={styles.page04OverlayText}>
        <h3>PNF STRETCH</h3>

        <p>
          THIS COURSE COMBINES RELAXATION OF
          <br />
          THE LOWER BODY MUSCLES WITH MUSCLE
          <br />
          WORKOUT MOVEMENTS.
        </p>
      </div>
    </div>
  </div>

  <div className={styles.page04CareList}>

    <div className={styles.page04CareItem}>
      <div className={styles.page04CareIcon}>
        <img src={Asset13} alt="" />
      </div>

      <div className={styles.page04CareText}>
        <h3>HAMSTRING RELAXATION</h3>

        <p>
          THIS COURSE STRETCHES AND RELAXES
          <br />
          HAMSTRING MUSCLES, WHICH FATIGUE
          <br />
          QUICKLY.
        </p>
      </div>
    </div>

    <div className={styles.page04CareItem}>
      <div className={styles.page04CareIcon}>
        <img src={Asset14} alt="" />
      </div>

      <div className={styles.page04CareText}>
        <h3>ROLLER STRETCH</h3>

        <p>
          THIS COURSE HELPS FLEXIBILITY IN THE
          <br />
          MUSCLES AROUND THE WAIST AND STRETCHES
          <br />
          THEM WITH ROTATIONAL MOVEMENTS.
        </p>
      </div>
    </div>

    <div className={styles.page04CareItem}>
      <div className={styles.page04CareIcon}>
        <img src={Asset15} alt="" />
      </div>

      <div className={styles.page04CareText}>
        <h3>PIRIFORMIS RELAXATION</h3>

        <p>
          THIS COURSE STRETCHES THE MUSCLES AT
          <br />
          THE BACK OF THE BUTTS TO HELP WITH
          <br />
          FLEXIBILITY.
        </p>
      </div>
    </div>

    <div className={styles.page04CareItem}>
      <div className={styles.page04CareIcon}>
        <img src={Asset16} alt="" />
      </div>

      <div className={styles.page04CareText}>
        <h3>ROBO REFRESH</h3>

        <p>
          THIS COURSE APPLIES ACUPRESSURE IN
          <br />
          AREAS WHERE FATIGUE ACCUMULATES
          <br />
          GREATLY WITH KNEADING MOVEMENTS.
        </p>
      </div>
    </div>

    <div className={styles.page04CareItem}>
      <div className={styles.page04CareIcon}>
        <img src={Asset17} alt="" />
      </div>

      <div className={styles.page04CareText}>
        <h3>ROBO RECOVERY</h3>

        <p>
          THIS COURSE APPLIES ACUPRESSURE MAINLY
          <br />
          ON THE NECK AND BACK AND HELPS THE
          <br />
          FLEXIBILITY OF THE LEGS.
        </p>
      </div>
    </div>

  </div>

  <div className={styles.page04Patents}>
    <span className={styles.page04PatentsBadge}>
      PATENTS
    </span>

    <div className={styles.page04PatentsText}>
      <p>
        · Massage device with massage ball to prevent non-ideal
        temperature rise
        &nbsp;&nbsp;(heating roller - temperature detection sensor)
        (No. 10-2451769)
      </p>

      <p>
        · Massage device comprising a massage unit capable of providing
        a thermal
        
        &nbsp;&nbsp;sensation (heating roller - through hole)
        (No. 10-2605796)
      </p>

      <p>
        · Massage module having a thermo-massage function

        &nbsp;&nbsp;(heating roller -reinforcement washer) (No. 10-2557438)
      </p>

      <p>
        · Massage module having a thermo-massage function

        &nbsp;&nbsp;(heating roller -through hole) (No. 10-2605795)
      </p>
    </div>
  </div>
</section>

<section className={styles.page05}>

  <section className={styles.page05Point02}>
    <span className={styles.page05Badge}>Point 02</span>

    <h2>
      AUDIO SPEAKERS
      <br />
      BY <strong>BANG &amp; OLUFSEN</strong>
    </h2>

    <p>
      <strong>BODYFRIEND</strong> and <strong>Bang &amp; Olufsen</strong> collaborated
      <br />
      to implement beyond sound quality for the
      <br />
      massage chair.
    </p>

    <img
      src={Asset20}
      alt="Bang & Olufsen audio speakers"
      className={styles.page05Point02Image}
    />
  </section>

  <section className={styles.page05Point03}>
    <span className={styles.page05Badge}>Point 03</span>

    <h2><strong>NATURAL</strong> LEATHER</h2>

    <p>
      The friction-prone interior uses premium <strong>natural</strong>
      <br />
      <strong>leather</strong> to provide a comfortable, soft seating
      <br />
      experience and add durability.
    </p>

    <img
      src={Asset21}
      alt="Quantum premium natural leather"
      className={styles.page05Point03Image}
    />
  </section>

  <section className={styles.page05Point04}>
    <span className={styles.page05Badge}>Point 04</span>

    <h2>
      HIGH-DEFINITION
      <br />
      <strong>10” FULL HD</strong>
      <br />
      TOUCH TABLET
    </h2>

    <img
      src={Asset22}
      alt="Quantum 10 inch full HD touch tablet"
      className={styles.page05Point04Image}
    />
  </section>

  <section className={styles.page05Point05}>
    <span className={styles.page05Badge}>Point 05</span>

    <h2>
      <strong>FINGER-MOVING</strong>
      <br />
      MASSAGE MODULE
    </h2>

    <p>
      A large and vivid <strong>high-resolution 10” display</strong>
      <br />
      lets you adjust intensity and temperature with a
      <br />
      single touch on a screen!
    </p>

    <img
      src={Asset23}
      alt="Quantum finger-moving massage module"
      className={styles.page05Point05Image}
    />

<div className={styles.page05Patents}>
  <span>PATENTS</span>

  <p>
    · A massage apparatus exercising the legs through the independent
    movement leg massage unit (cycling mode) (No. 10-2690746)
  </p>

  <p>
    · A massage apparatus including a plurality of independently actuated leg
    massage parts and operating method thereof (No. 10-2652704)
  </p>

  <p>
    · Massage device comprising a massage unit capable of providing a thermal
    sensation (heating roller - through hole) (No. 10-2605796)
  </p>

  <p>
    · Massage module having a thermo-massage function (heating roller -
    reinforcement washer) (No. 10-2557438)
  </p>

  <p>
    · Massage module having a thermo-massage function (heating roller -
    through hole) (No. 10-2605795)
  </p>
</div>
  </section>

  <section className={styles.page05Point06}>
    <span className={styles.page05Badge}>Point 06</span>

    <h2>
      HIGH-END
      <br />
      <strong>HEALTHCARE</strong>
      <br />
      MASSAGE MODE
    </h2>

    <p>
      High-end healthcare massage provides <strong>spine</strong>
      <br />
      <strong>mode acupressure</strong> centered on the back and waist.
    </p>

    <img
      src={Asset24}
      alt="Quantum high-end healthcare massage mode"
      className={styles.page05Point06Image}
    />

    <div className={styles.page05ModeGrid}>

      <div className={styles.page05ModeItem}>
        <img src={Asset25} alt="" />
        <span>
          Spine
          <br />
          Mode
        </span>
      </div>

      <div className={styles.page05ModeItem}>
        <img src={Asset26} alt="" />
        <span>
          Soft Spine
          <br />
          Mode
        </span>
      </div>

      <div className={styles.page05ModeItem}>
        <img src={Asset27} alt="" />
        <span>
          Swelling
          <br />
          Relief
        </span>
      </div>

      <div className={styles.page05ModeItem}>
        <img src={Asset28} alt="" />
        <span>
          Hangover
          <br />
          Relief
        </span>
      </div>

      <div className={styles.page05ModeItem}>
        <img src={Asset29} alt="" />
        <span>
          Suboccipital
          <br />
          Release
        </span>
      </div>

      <div className={styles.page05ModeItem}>
        <img src={Asset30} alt="" />
        <span>
          Perineal
          <br />
          Massage
        </span>
      </div>

    </div>

<div className={styles.page05BottomPatents}>
  <span>PATENTS</span>

<p>
  · Massage apparatus for releasing user's stress and methods thereof
  <br />
  (No. 10-2494127)
</p>
  <p>
    · Perineal region massage device for massage device, and method for
    controlling the same (No. 10-2220566)
  </p>
</div>
  </section>

</section>

<section className={styles.page06}>

  <img
    src={Quantum06Bg}
    alt=""
    className={styles.page06Bg}
  />

  <div className={styles.page06Safety}>

    <img
      src={SafetyIcon}
      alt=""
      className={styles.page06SafetyIcon}
    />

<h2 className={styles.page06SafetyTitle}>
  <strong>15 SAFETY</strong> SENSOR
</h2>

    <div className={styles.page06SafetyDescription}>
      <p>User’s safety considered 15 detection sensors.</p>
      <p>They detect objects to prevent risk.</p>
    </div>

    <img
      src={SafetyImage}
      alt="Quantum 15 safety sensor system"
      className={styles.page06SafetyImage}
    />

    <div className={styles.page06Patent}>
      <span>Patent</span>

      <p>
        No. 10-2547118: Massage apparatus, including a sensor for safety
      </p>
    </div>

  </div>

  <div className={styles.page06Divider}></div>

  <div className={styles.page06Power}>

    <img
      src={PowerIcon}
      alt=""
      className={styles.page06PowerIcon}
    />

<h2 className={styles.page06PowerTitle}>
  POWER CUT <strong>PROTECTION</strong>
</h2>

    <div className={styles.page06PowerDescription}>
      <p>
        What if the massage chair stops operating due to a power outage?
      </p>

      <p>
        Press and hold the left quick button.
      </p>

      <p>
        You can restore the massage chair to its original state.
      </p>
    </div>

    <img
      src={PowerImage}
      alt="Quantum power cut protection quick button"
      className={styles.page06PowerImage}
    />

    <div className={styles.page06Patent}>
      <span>Patent</span>

      <p>
        No. 10-2259522: Massage device capable of resetting position
        
        when power failure and operation method thereof
      </p>
    </div>

  </div>

</section>

<section className={styles.page07}>

  <img
    src={Quantum07Bg}
    alt=""
    className={styles.page07Bg}
  />

  <header className={styles.page07Header}>
    <h2>
      QUANTUM’s technology
      <br />
      that is a step ahead
    </h2>
  </header>

  <div className={`${styles.page07Feature} ${styles.page07Feature01}`}>
    <img
      src={Asset42}
      alt="Bluetooth speaker and entertainment mode"
    />

    <p>
      <span>01</span>
      Bluetooth speaker/entertainment mode
    </p>
  </div>

  <div className={`${styles.page07Feature} ${styles.page07Feature02}`}>
    <img
      src={Asset43}
      alt="3-step sole acupressure roller"
    />

    <p>
      <span>02</span>
      3-step sole acupressure roller
    </p>
  </div>

  <div className={`${styles.page07Feature} ${styles.page07Feature03}`}>
    <img
      src={Asset44}
      alt="Inner key for simple left and right operation"
    />

    <p>
      <span>03</span>
      Inner key for simple left and right operation
    </p>
  </div>

  <div className={`${styles.page07Feature} ${styles.page07Feature04}`}>
    <img
      src={Asset45}
      alt="81 air pockets"
    />

    <p>
      <span>04</span>
      81 air pockets
    </p>
  </div>

  <div className={`${styles.page07Feature} ${styles.page07Feature05}`}>
    <img
      src={Asset46}
      alt="Wireless charging pad and USB charging port"
    />

    <p>
      <span>05</span>
      Wireless charging pad and USB charging port
    </p>

    <div className={styles.page07Patent}>
      Patent&nbsp; | &nbsp;No. 10-2358868: Massage device capable of
      wireless charging and operation method thereof
    </div>
  </div>

  <div className={`${styles.page07Feature} ${styles.page07Feature06}`}>
    <img
      src={Asset47}
      alt="Maximum 50 degree heating"
    />

    <p>
      <span>06</span>
      Maximum 50°C heating for the
      <br />
      back, waist, calves, and soles
    </p>
  </div>

</section>


    </article>
  );
};

export default Quantum;